export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Portfolio von Enrico Reinsdorf, Senior UX Designer aus Nürnberg. Expertise in User Experience Design, Usability Engineering, Design Systems und Product Ownership."},{"name":"keywords","content":"UX Designer, Senior UX Designer, Nürnberg, CPUX-F, User Experience, Usability Engineering, Design System, User Research, Product Owner"},{"name":"author","content":"Enrico Reinsdorf"},{"property":"og:site_name","content":"Enrico Reinsdorf - UX Designer"},{"property":"og:type","content":"website"},{"property":"og:locale","content":"de_DE"},{"property":"og:title","content":"Enrico Reinsdorf - Senior UX Designer aus Nürnberg"},{"property":"og:description","content":"Portfolio von Enrico Reinsdorf, Senior UX Designer. Expertise in UX Design, Usability Engineering und Design Systems."},{"property":"og:url","content":"https://re-design.de"},{"property":"og:image","content":"https://re-design.de/images/og-image.jpg"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Enrico Reinsdorf - Senior UX Designer"},{"name":"twitter:description","content":"Portfolio von Enrico Reinsdorf, Senior UX Designer aus Nürnberg"},{"name":"twitter:image","content":"https://re-design.de/images/og-image.jpg"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"alternate icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"de"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1","title":"Enrico Reinsdorf - Senior UX Designer"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true